/*globals document, window, $, isMobile, LINK */

/**
 * Extension of default Bootstrap accordion
 * 
 */

var ACCORDIONS = [];

$(document).ready(function () {
    "use strict";

    document.addEventListener("wps_after_search_results", function() {
        $.each($("[data-accordion]"), function () {
            ACCORDIONS.push(new Accordion($(this)));
        });
        //resetAccordions();
    });
});

$(window).load(function () {
    "use strict";

    $.each($("[data-accordion]"), function () {
        ACCORDIONS.push(new Accordion($(this)));
    });
});

$(window).resize(resetAccordions);

function resetAccordions() {
    "use strict";

    var i = 0;

    if (ACCORDIONS.length === 0) {
        return;
    }

    for (i; i < ACCORDIONS.length; i += 1) {
        ACCORDIONS[i].reset();
    }
}

function Accordion(e) {
    "use strict";
    
    var scope = this,
        accordion,
        
        // Constant variables
        contentBreakId = "default-content",
        contentDevice,
        deviceColNumber = {
            "mobile": 2,
            "desktop": 4
        },

        // Scoped variables
        defaultContentHeight = 0,
        
        originalOrder,
        alphaOrder;

    function init() {
        scope.accordion = e;
        //e.find(".panel-collapse").css("height", 0);

        var accordionImages = e.find("img"),
            imagesLoaded = 0;

        scope.accordion.on("accordion_images_loaded", function() {
            setEventHandlers();
            setContent();
        });
        scope.accordion.trigger("accordion_images_loaded");

        $.each(accordionImages, function () {
            $(this).on("load", function () {
                imagesLoaded ++;

                if (imagesLoaded >= accordionImages.length) {
                    scope.accordion.trigger("accordion_images_loaded");
                }
            });
        });
    }

    function setContent() {
        contentDevice = isMobile() ? "mobile" : "desktop";
        if (scope.accordion.find(".panel-collapse").hasClass("collapse")) {
            setDefaultContent();
        }
        moveAdditionalProduct();
        setRowHeight();
    }

    function getContentBreak() {
        var availableBreaks = scope.accordion.find("[data-" + contentBreakId + "]"),
            currentDeviceBreak;

        if (availableBreaks.length === 0) {
            return false;
        }

        $.each(availableBreaks, function () {
            if ($(this).data(contentBreakId) === contentDevice && !$(this).is(":hidden")) {
                currentDeviceBreak = $(this);
            }
        });

        if (!currentDeviceBreak) {
            return false;
        }
        return currentDeviceBreak;
    }
    
    function setDefaultContent() {
        var curContentBreak = getContentBreak(),
            toggleBtn = scope.accordion.find("[data-toggle]");

        if (!curContentBreak) {
            toggleBtn.addClass("invisible");
        } else {
            scope.defaultContentHeight = curContentBreak.position().top + curContentBreak.height();

            toggleBtn.removeClass("invisible");
            setDefaultContentHeight();
        }
    }

    function setDefaultContentHeight() {
        scope.accordion.find(".panel-collapse")
            .css("height", scope.defaultContentHeight)
            .css("min-height", scope.defaultContentHeight);
    }

    function setRowHeight() {
        var accdChildren = scope.accordion.find(".panel-collapse").children(),
            curRow = [],
            curRowHeight = 0,
            accdChild,
            curRowChild,
            childCount = 1;
            //curDevice = isMobile() ? "mobile" : "desktop";

        $.each(accdChildren, function () {
            accdChild = $(this);
            accdChild.css("height", "auto");

            if (accdChild.children().hasClass("productInfo")) {
                if (accdChild.height() > curRowHeight) {
                    curRowHeight = accdChild.height();
                }
                curRow.push(accdChild);
            }

            if ((accdChild.hasClass("clearfix") && !accdChild.is(":hidden")) || childCount === accdChildren.length) {
                $.each(curRow, function () {
                    curRowChild = $(this);

                    curRowChild.css("height", curRowHeight + "px");
                });
                curRow = [];
                curRowHeight = 0;
            }

            if (accdChild.hasClass("clearfix") && childCount === accdChildren.length && (accdChild.data(contentBreakId) === contentDevice || accdChild.prev().data(contentBreakId) === contentDevice)) {
                scope.accordion.find("[data-toggle]").addClass("invisible");
            }
            childCount += 1;
        });
    }

    function moveAdditionalProduct() {
        var products = getListItems(),
            position = deviceColNumber[contentDevice],
            additionalProduct;

        $.each(products, function(key, value) {
            if ($(value).hasClass("additional-product")) {
                additionalProduct = $(value);
                products.splice(key, 1);
                return false;
            }
        });
        
        if (additionalProduct && additionalProduct.length > 0) {
            products.splice(position - 1, 0, additionalProduct[0]);
            addOrderedItems(setListItems(products));
        }
    }
    
    // Ordering functions
    
    function getListItems() {
        return scope.accordion.find(".product-list-item");
    }
    
    function setListItems(list) {
        var productList = [],
            productNode;
        
        $.each(list, function () {
            productNode = $(this).clone().removeAttr("id");
            
            productList.push([$(this).find(".product-title").text(), productNode]);
        });
        return productList;
    }
    
    function getAlphaOrder() {
        return scope.alphaOrder;
    }

    function setAlphaOrder(list) {
        var productList = setListItems(getListItems()),
            sortedList = [],
            returnList = [],
            productCount = 0,
            i = 0;
    
        if (!alphaOrder) {
            scope.originalOrder = setListItems(getListItems());
        }

        sortedList = setListItems(getListItems()).sort(function (a, b) {
            if (a[0] < b[0]) {
                return -1;
            }
            if (a[0] > b[0]) {
                return 1;
            }
        });

        for (i; i < productList.length; i += 1) {
            if (!productList[i][1].hasClass("additional-product")) {
                returnList.push(sortedList[productCount]);
                productCount++;
            } else {
                returnList.push(productList[i]);
            }
        }
        scope.alphaOrder = returnList;
    }

    function getOriginalOrder() {
        return scope.originalOrder;
    }

    function addOrderedItems(newList) {
        var oldItem,
            newItem,
            speed = 200;
        
        $.each(getListItems(), function (key, value) {
            oldItem = $("#" + value.id);
            newItem = newList[key][1];
            
            newItem.attr("id", "product-item-" + $(value).parent().attr("id") + "-" + key + "-" + Date.now());
            
            oldItem.replaceWith(newItem);
//            oldItem.fadeOut(speed, function () {
//                $(this).replaceWith(newItem);
//                newItem.fadeIn(speed);
//            });
        });
    }

    // Add event handlers
    function setEventHandlers() {
        scope.accordion.on("hide.bs.collapse", function () {
            addOrderedItems(getOriginalOrder());
        });

        scope.accordion.on("show.bs.collapse", function () {
            setAlphaOrder();
            addOrderedItems(getAlphaOrder());
            setRowHeight();
        });

        scope.accordion.on("shown.bs.collapse", function (e) {
            var targetId = e.target.id,
                idPrefix = "collapse-",
                anchorId = targetId.substring(idPrefix.length, targetId.length),
                anchorLink = $("a[data-custom-link][href=\"#" + anchorId + "\"]")[0];

            if (anchorLink) {
                LINK.scroll($("a[data-custom-link][href=\"#" + anchorId + "\"]")[0], 0, 250);
            }
            $(this).find("[data-toggle]").addClass("invisible");
        });

        scope.accordion.on("hidden.bs.collapse", function () {
            $(this).find("[data-toggle]").removeClass("invisible");
        });
    }

    init();

    return {
        "reset": setContent
    };
}